<template>
<div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
    <div v-if="postes.length > 0" class="alert alert-warning mb-20">
        Veuillez suivre l'ordre des postes. Le numéro d'ordre est défini automatiquement.
    </div>
    <Form ref="organeForm" @submit="addOrgane" :validation-schema="organeSchema">
        <div class="row">
        <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
                Nom de l'organe <span class="text-danger">*</span>
            </label>
            <Field
                name="nom"
                type="text"
                class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom de l'organe"
            />
            <ErrorMessage name="nom" class="text-danger" />
            </div>
        </div>

        <div class="col-md-12">
            <div class="d-flex justify-content-between align-items-center mb-15">
            <h5 class="fw-semibold text-black">Postes de l’organe</h5>
            </div>
        </div>

        <div
            v-for="(poste, index) in postes"
            :key="index"
            class="col-md-12 border rounded p-15 mb-15 bg-light"
        >
            <h6 class="fw-bold mb-10 text-primary">Poste {{ index + 1 }}</h6>

            <div class="row">
            <div class="col-md-4">
                <div class="form-group mb-10">
                <label class="d-block text-black fw-semibold mb-5">
                    Nom du poste <span class="text-danger">*</span>
                </label>
                <input
                    v-model="poste.nomPoste"
                    type="text"
                    class="form-control shadow-none text-black"
                    placeholder="Ex: Maire, Conseiller..."
                />
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group mb-10">
                <label class="d-block text-black fw-semibold mb-5">
                    Numéro d'ordre
                </label>
                <input
                    v-model.number="poste.numeroOrdre"
                    type="number"
                    min="1"
                    class="form-control shadow-none text-black bg-light" 
                    readonly
                />
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group mb-10">
                <label class="d-block text-black fw-semibold mb-5">
                    Arrondissement <span class="text-danger"></span>
                </label>
                <Multiselect
                    v-model="poste.arrondissementId"
                    :options="arrondissementsOptions"
                    placeholder="Sélectionner un arrondissement"
                    label="label"
                    track-by="value"
                    :searchable="true"
                    class="shadow-none"
                />
                </div>
            </div>

            <div class="col-md-1 d-flex align-items-end mb-15">
                <button
                type="button"
                class="btn btn-danger btn-sm"
                @click="supprimerPoste(index)"
                >
                <i class="flaticon-delete"></i>
                </button>
            </div>
            </div>
        </div>
        <div class="col-md-12 text-end mb-15">
            <button
                type="button"
                class="btn btn-outline-success btn-sm"
                @click="ajouterPoste"
            >
                + Ajouter un poste
            </button>
        </div>

        <!-- Boutons de validation -->
        <div class="col-md-12 mt-15">
            <div class="d-flex align-items-center">
            <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 bg-success"
                type="submit"
            >
                Valider
            </button>
            <router-link
                to="/liste-organes"
                class="btn btn-danger transition border-0 lh-1 fw-medium"
            >
                <i class="flaticon-delete lh-1 me-1"></i> Annuler
            </router-link>
            </div>
        </div>
        </div>
    </Form>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import ApiService from "@/services/ApiService";
import { success, error } from "@/utils/utils";
import { useRouter } from "vue-router";
import Multiselect from "@vueform/multiselect";

export default defineComponent({
name: "AjouterOrgane",
components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
},
setup() {
    const router = useRouter();
    const postes = ref<any[]>([]);
    const arrondissementsOptions = ref([]);


    const organeSchema = Yup.object().shape({
    nom: Yup.string().required("Le nom de l'organe est obligatoire"),
    });

    const fetchArrondissements = async () => {
    try {
        const response = await ApiService.get("/all/arrondissements");
        const data = response.data.data.data;
        console.log("responseeeeeeee", response);
        arrondissementsOptions.value = data.map((arr) => ({
        value: arr.id,
        label: `${arr.libelle}`,
        }));
        console.log("Arrondissements chargés :", arrondissementsOptions.value);
    } catch (err) {
        error("Erreur lors du chargement des arrondissements");
    }
    };


    const ajouterPoste = () => {
    postes.value.push({
        nomPoste: "",
        numeroOrdre: postes.value.length + 1,
        arrondissementId: null,
    });
    };


    const supprimerPoste = (index: number) => {
    postes.value.splice(index, 1);
    };

    const addOrgane = async (values: any, { resetForm }: any) => {
    if (postes.value.length < 1) {
        error("Veuillez ajouter au moins un poste !");
        return;
    }
    
    const payload = {
        nom: values.nom,
        postes: postes.value.map((p) => ({
        nomPoste: p.nomPoste,
        numeroOrdre: p.numeroOrdre,
        arrondissementId: p.arrondissementId
        })),
    };
        console.log("Payload envoyé :", payload);
    try {
        const { data } = await ApiService.post("/organe", payload);
        if (data.code === 200 || data.code === 201) {
        success("Organe créé avec succès !");
        resetForm();
        postes.value = [];
        router.push({ name: "liste-organes" });
        }
    } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors de la création !");
    }
    };

    onMounted(async () => {
    fetchArrondissements();
    if (postes.value.length === 0) {
    ajouterPoste();
        }
    });

    return {
    organeSchema,
    addOrgane,
    postes,
    ajouterPoste,
    supprimerPoste,
    arrondissementsOptions,
    };
},
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
